<template>
  <div class="w-full max-w-2xl" :dir="isRtl === true ? 'rtl' : 'ltr'">
    <div class="grid grid-cols-2 w-full -m-2">
      <div v-for="option in jobOptions" :key="option.id" class="p-2">
        <button
          type="button"
          @click="selectJob(option.id)"
          class="p-4 border rounded-2xl transition-colors flex flex-col justify-between h-28 group w-full shadow-sm hover:shadow-md bg-white/90 dark:bg-slate-900/70"
          :class="selectedJob === option.id ? 'border-stone-400 dark:border-stone-500 bg-stone-100 dark:bg-stone-800' : 'border-stone-200 dark:border-stone-700 hover:bg-stone-50 dark:hover:bg-stone-800/70'"
          :style="isRtl === true ? { textAlign: 'right' } : { textAlign: 'left' }"
        >
          <span class="text-slate-700 dark:text-stone-50 font-medium leading-6">{{ option.label }}</span>
          <div class="flex justify-end">
            <span class="w-10 h-10 rounded-xl bg-stone-100 dark:bg-stone-800 border border-stone-200 dark:border-stone-700 flex items-center justify-center group-hover:bg-stone-200 dark:group-hover:bg-stone-700 transition-colors">
              <Icon :icon="option.icon" class="text-stone-500 group-hover:text-stone-700 dark:text-stone-300 dark:group-hover:text-stone-100" width="20" />
            </span>
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { Icon } from '@iconify/vue/dist/offline';
import { useI18n } from '@/i18n';

const props = defineProps({
  selectedJob: {
    type: String,
    default: ''
  }
});

const emit = defineEmits(['update:selectedJob', 'select']);

const { t, currentLanguage, availableLanguages } = useI18n();

const isRtl = computed(() => {
  const language = availableLanguages.value.find((item) => item.code === currentLanguage.value);
  if (language === undefined || language === null) {
    return false;
  }
  return language.dir === 'rtl';
});

const jobOptions = computed(() => [
  {
    id: 'websiteSupport',
    label: t('agentCreate.job.websiteSupport', 'Website front support agent'),
    icon: 'tabler:world'
  },
  {
    id: 'internalOps',
    label: t('agentCreate.job.internalOps', 'Internal operations assistant'),
    icon: 'tabler:building'
  },
  {
    id: 'sales',
    label: t('agentCreate.job.sales', 'Sales agent'),
    icon: 'tabler:user-star'
  },
  {
    id: 'onboarding',
    label: t('agentCreate.job.onboarding', 'Customer onboarding agent'),
    icon: 'tabler:rocket'
  }
]);

function selectJob(id) {
  emit('update:selectedJob', id);
  emit('select', id);
}

function resolveLabel(jobId, customJob) {
  if (jobId !== '') {
    const match = jobOptions.value.find((item) => item.id === jobId);
    if (match !== undefined) {
      return match.label;
    }
  }
  return customJob;
}

defineExpose({
  resolveLabel
});
</script>
